export default "__VITE_ASSET__yRY59l9___"